import { Component, CUSTOM_ELEMENTS_SCHEMA, effect, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Button } from '@shui/angular';
import { ShDatepickerAccessorComponent } from '../../../ui/sh-datepicker-accessor/sh-datepicker-accessor.component';
import { ShUserPickerComponent } from '../../../ui/sh-user-picker/sh-user-picker.component';
import { OutOfOfficeEntryEditorValue } from '../../models/out-of-office.model';

export type { OutOfOfficeEntryEditorValue };

@Component({
    selector: 'app-out-of-office-entry-editor',
    standalone: true,
    templateUrl: './out-of-office-entry-editor.component.html',
    imports: [ReactiveFormsModule, TranslatePipe, Button, ShDatepickerAccessorComponent, ShUserPickerComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OutOfOfficeEntryEditorComponent {
    public readonly dateRange = input<Date[]>([]);
    public readonly user = input<string>('');
    public readonly mode = input<'create' | 'edit'>('edit');
    public readonly isSaving = input<boolean>(false);

    public readonly updateClicked = output<OutOfOfficeEntryEditorValue>();
    public readonly deleteClicked = output<void>();
    public readonly cancelClicked = output<void>();

    protected readonly form = new FormGroup({
        dateRange: new FormControl<Date[]>([]),
        user: new FormControl<string>('')
    });

    constructor() {
        effect(() => {
            this.form.patchValue(
                {
                    dateRange: this.dateRange(),
                    user: this.user()
                },
                { emitEvent: false }
            );
        });
    }

    protected onUpdate(): void {
        this.updateClicked.emit({
            dateRange: this.form.controls.dateRange.value ?? [],
            user: this.form.controls.user.value ?? ''
        });
    }

    protected onDelete(): void {
        this.deleteClicked.emit();
    }

    protected onCancel(): void {
        this.cancelClicked.emit();
    }
}
